import Lottie from 'lottie-react';
import policeReportAnimation from '@/assets/animations/police-report.json';
import weatherReportAnimation from '@/assets/animations/weather-report.json';

interface MediaThumbnailProps {
  eventId: string;
  eventType: string;
  className?: string;
}

export function MediaThumbnail({
  eventId: _eventId,
  eventType,
  className = '',
}: MediaThumbnailProps) {
  const getAnimationForEventType = (type: string) => {
    const normalizedType = type.toLowerCase().replace(/[_\s]/g, '');

    switch (normalizedType) {
      case 'policereport':
        return policeReportAnimation;
      case 'weatherreport':
        return weatherReportAnimation;
      default:
        return null;
    }
  };

  const animation = getAnimationForEventType(eventType);

  return (
    <div
      className={`w-16 h-16 flex-shrink-0 bg-gray-200 relative overflow-hidden ${className}`}
    >
      {animation ? (
        <Lottie
          animationData={animation}
          loop={true}
          className="w-full h-full"
        />
      ) : (
        <div className="w-full h-full bg-gray-300 flex items-center justify-center">
          <div className="w-6 h-6 bg-gray-400"></div>
        </div>
      )}
    </div>
  );
}
